import React from 'react'

type Props = {
    error: string
}

export default function ErrorMsg(props: Props) {
    return (
        <div className='my-2 px-5 py-4 bg-gray-50 shadow text-red-500 border border-red-200'>
            <span className='font-bold'>Error:</span> {props.error}
        </div>
    )
}
